/*
try{

    var debugFunction = true;
    var Uploader = {  
        currrentStep    : 1, 
        allSteps        : [], 
        formSteps       : [], 
        uploader        : null,  
        bypass_step     : false,   
        uploader_first_ste_validator   : true,     
        max_secondary_display : 1000,
        max_stickers : 1000, 
        max_videos : 1000, 
        max_sticker_boxes : 1000, 
        max_instant_win : 1000,
        max_coolers : 1000, 
        max_wow_displays : 1000,
        max_monster_metal_rack : 1000,
        max_permanent_energy_beverage : 1000,
        max_monster_display : 1000,
        max_monster_claw_sticker : 1000,
        max_npd : 1000,
        max_hamilton_npd : 1000,
        max_coolers_single : 1000, 
        max_prowler_sticker: 1000, 
        employeeCountry : 0,        
        selectedSpot : {
            group : null,
            position : null
        },
        data : {
            general : {},
            images  : {
                product_display : [],      
                secondary_display : [],      
                stickers : [],  
                videos : [],
                sticker_boxes : [], 
                instant_win:[],
                coolers : [],   
                coolers_single : [], 
                wow_displays : [],
                monster_metal_rack : [],
                permanent_energy_beverage : [],
                monster_display : [],
                monster_claw_sticker: [],
                npd: [],
                hamilton_npd: [],
                prowler_sticker: [],
            }        
        },
        toggleAllPills:function($this){  


            $this.toggleClass('checked');
            let inputName= $this.data('name');            
            const action = $this.hasClass('checked');            
            $this.closest('.option-pills-group').find('input[name="'+inputName+'"]').each(function(){
                $(this).prop('checked', action);
            });          
            Uploader.formStatus($this.closest('form'));
        },
        pillsCheckboxChanged:function($this){  
            let inputName= $this.attr('name');
            const theToggler = $this.closest('.option-pills-group').find('.toggle-all-pills');
            if($this.closest('.option-pills-group').find('input[name="'+inputName+'"]').length > $this.closest('.option-pills-group').find('input[name="'+inputName+'"]:checked').length){
                theToggler.removeClass('checked');
            }else{
                theToggler.addClass('checked');
            }
        },
        dropdownCheckboxChanged:function($this){     
            var $label  = $this.data('label');          
            if($this.closest('.dropdown').length>0){
                if($this.get(0).checked) {
                    $this.closest('.dropdown').find('.dropdown-toggle span').html($label);
                    $this.closest('.dropdown').find('.dropdown-toggle span').addClass('font-bold');                    
                }else{
                    $this.closest('.dropdown').find('.dropdown-toggle span').html(
                        $this.closest('.dropdown').find('.dropdown-toggle').data('label')                    
                    );
                    $this.closest('.dropdown').find('.dropdown-toggle span').removeClass('font-bold');
                }
            }
        },
        
        uploadImage:function($this){ 

            Uploader.selectedSpot.group    = $this.data('group');
            Uploader.selectedSpot.position = $this.data('position');  
            var step = $this.closest('.uploaded-files-group').data('step');

            if( $this.closest('.uploaded-files-group').hasClass('active') ){
                if( $this.data('group') =='videos'){
                   $('.uploader-video-container  .select-img').trigger('click');
                }else{
                  $('.uploader-container:not(.uploader-video-container) .select-img').trigger('click');
                }
            
            }else if(Uploader.selectedSpot.group  === 'product_display'){
                Uploader.steps(2);
               if( $this.data('group') =='videos'){
                   $('.uploader-video-container  .select-img').trigger('click');
                }else{
                  $('.uploader-container:not(.uploader-video-container) .select-img').trigger('click');
                }
               
            }else{
                if( Uploader.steps(step) ) {
                    if( $this.data('group') =='videos'){
                   $('.uploader-video-container  .select-img').trigger('click');
                }else{
                  $('.uploader-container:not(.uploader-video-container) .select-img').trigger('click');
                }
                }                     
            }
        }, 
        
        addRow:function( $group, $this){
            var canAddRow = true;
            var step = $this.closest('.uploaded-files-group').data('step');
            $required = typeof($('.uploaded-files-group-list[data-group="'+$group+'"]').data('required_step'))!=='undefined' ? $('.uploaded-files-group-list[data-group="'+$group+'"]').data('required_step') : 'required'; 
               
            if(typeof(step)=='undefined' || typeof(step)=='' ){
                canAddRow = false;
            }
            Uploader.stepsStatus(step,false);
            if(Uploader.currrentStep !== step){
                if(!Uploader.steps(step)){
                    canAddRow = false;
                }
            }
            if(canAddRow){
                max_items = 3;
                $position = $('.uploaded-files-group-list[data-group="'+$group+'"]').find('.upload-placeholder-item').length / 2;      // 1 , 2 , 3
                $rowIndex = ($('.uploaded-files-group-list[data-group="'+$group+'"]').find('.uploaded-files-group-row').length /2) +1; 
               
                if($group == 'secondary_display' || $group == 'coolers' || $group =='monster_metal_rack' || $group =='permanent_energy_beverage'
                     || $group == 'monster_display' ){        
                  
                    if($group == 'secondary_display'){
                      max_items = Uploader.coolers;
                  }else if($group == 'secondary_display'){
                      max_items = Uploader.max_coolers;
                    }else if($group == 'monster_metal_rack'){
                         max_items = Uploader.max_monster_metal_rack;
                     }else if($group == 'permanent_energy_beverage'){
                         max_items = Uploader.max_permanent_energy_beverage;
                     }else if($group == 'monster_display'){
                         max_items = Uploader.max_monster_display;
                     }

                    template = `<div class="uploaded-files-group-row " data-row-index="${$rowIndex}">
                                    <div class="row align-items-center">
                                        <div class="col-4">
                                            ${Uploader.getImagePlaceHolder($group, $position,$required )} 
                                        </div>
                                        <div class="col-4">
                                            ${Uploader.getImagePlaceHolder($group, $position+1, $required)}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-4">
                                            <h6 class="no-margin font-alt-regular text-center font16">#BEFORE</h6>
                                        </div>
                                        <div class="col-4">
                                            <h6 class="no-margin font-alt-regular text-center font16">#AFTER</h6>
                                        </div>
                                    </div>
                                      <span class="removeTagsRow" onclick="Uploader.triggerRemoveTagsRow('${$rowIndex}','${$group}');">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 10.4 10.4" style="enable-background:new 0 0 10.4 10.4;" xml:space="preserve">
                                            <path d="M10,8.4L6.8,5.2L10,2c0.4-0.4,0.4-1.2,0-1.6c-0.4-0.4-1.2-0.4-1.6,0L5.2,3.6L2,0.3c-0.4-0.4-1.2-0.4-1.6,0s-0.4,1.2,0,1.6  l3.2,3.2L0.3,8.4c-0.4,0.4-0.4,1.2,0,1.6c0.4,0.4,1.2,0.4,1.6,0l3.2-3.2L8.4,10c0.4,0.4,1.2,0.4,1.6,0C10.5,9.6,10.5,8.9,10,8.4z"></path>
                                        </svg>
                                    </span>
                                </div>`;

                } else if($group == 'stickers' || $group == 'videos' || $group == 'sticker_boxes'  || $group == 'coolers_single' || $group == 'instant_win' || $group == 'wow_displays' 
                    || $group =='monster_claw_sticker' ||  $group =='npd'||  $group =='hamilton_npd'  ){     
                    if($group == 'stickers'){
                         max_items = Uploader.max_stickers;
                     }else if($group == 'sticker_boxes'){
                         max_items = Uploader.max_sticker_boxes;
                     }else if($group == 'videos'){
                         max_items = Uploader.max_videos;
                     }else if($group == 'instant_win'){
                         max_items = Uploader.max_instant_win;
                     }else if($group == 'wow_displays'){
                         max_items = Uploader.max_wow_displays;
                     }else if($group == 'monster_claw_sticker'){
                         max_items = Uploader.max_monster_claw_sticker;
                     }else if($group == 'npd'){
                         max_items = Uploader.max_npd;
                     }else if($group == 'hamilton_npd'){
                         max_items = Uploader.max_hamilton_npd;
                     }else if($group == 'coolers_single'){
                         max_items = Uploader.max_coolers_single;
                     }else if($group == 'prowler_sticker'){
                         max_items = Uploader.max_prowler_sticker;
                     }


                   
                    template = `<div class="col-6 col-md-4 col-pusher uploaded-files-group-row" style="padding:0 15px 30px" data-row-index="${$rowIndex}">
                                    ${Uploader.getImagePlaceHolder($group,$position,$required)}

                                      <span class="removeTagsRow" onclick="Uploader.triggerRemoveTagsRow('${$rowIndex}','${$group}');">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 10.4 10.4" style="enable-background:new 0 0 10.4 10.4;" xml:space="preserve">
                                            <path d="M10,8.4L6.8,5.2L10,2c0.4-0.4,0.4-1.2,0-1.6c-0.4-0.4-1.2-0.4-1.6,0L5.2,3.6L2,0.3c-0.4-0.4-1.2-0.4-1.6,0s-0.4,1.2,0,1.6  l3.2,3.2L0.3,8.4c-0.4,0.4-0.4,1.2,0,1.6c0.4,0.4,1.2,0.4,1.6,0l3.2-3.2L8.4,10c0.4,0.4,1.2,0.4,1.6,0C10.5,9.6,10.5,8.9,10,8.4z"></path>
                                        </svg>
                                    </span>
                                </div>`;           
                }

                $('.col-bottom-left .uploaded-files-group-list[data-group="'+$group+'"]').append(template);

                var $theTagsParent = $('.uploaded_image_tags.'+$group+'_tags');   
                var $tagsRowIndex  = $theTagsParent.find('.uploaded-files-group-row').length + 1;

                var  $tagsRowTemplate  = `<div class="partial" data-partial="upload.tags.${$group}"  data-tags_index="${$tagsRowIndex}"></div>`;
                $theTagsParent.append($tagsRowTemplate);

                load_partial($theTagsParent.find('.partial:last-child'),function(){
                    if($('.uploaded-files-group-list[data-group="'+$group+'"] .uploaded-files-group-row').length/2 >= max_items){
                        $('.uploaded-files-group-list[data-group="'+$group+'"] .add-row').hide();
                    }
                    $this.removeClass('btn-disabled');
                    $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'addRow,');
                });
            }
            if($.trim($required) =='required' ){
                $('.steps-navigation .btn-nav').addClass('btn-disabled'); 
            }
             
            Uploader.openMobileNextStep();
           
        },
         triggerRemoveTagsRow:function($index,$group){
             $('.uploaded_image_tags[data-group="'+$group+'"] [data-tags_index="'+$index+'"] .removeTagsRow').trigger('click');
         },
        removeTagsRow:function($this,$group){

            var $tagsRow        = $this.closest('.partial');
            var $tagsImageGroup = $tagsRow.data('tags_index');
            $tagsRow.remove();   
            $('.uploaded-files-group-list[data-group="'+$group+'"]').find('.uploaded-files-group-row[data-row-index="'+$tagsImageGroup+'"] .upload-placeholder-item').each(function(){
                var index = $(this).data('position'); 
                if(typeof Uploader.data.images[$group][index] !== 'undefined' ){
                    Uploader.data.images[$group].splice(index, 1);
                }
            });        
            $('.uploaded-files-group-list[data-group="'+$group+'"]').find('.uploaded-files-group-row[data-row-index="'+$tagsImageGroup+'"]').remove();
            var max_items =3; 
            if($group == 'secondary_display'){     
                max_items = Uploader.max_secondary_display;
            }else if($group == 'stickers'){     
                max_items = Uploader.max_stickers;
            }else if($group == 'videos'){     
                max_items = Uploader.max_videos;
            }else if($group == 'sticker_boxes'){     
                max_items = Uploader.max_sticker_boxes;
            }else if($group == 'coolers'){     
                max_items = Uploader.max_coolers;
            }else if($group == 'instant_win'){     
                max_items = Uploader.max_instant_win;
            }else if($group == 'wow_displays'){     
                max_items = Uploader.max_wow_displays;
            }else if($group == 'monster_metal_rack'){     
                max_items = Uploader.max_monster_metal_rack;
            }else if($group == 'permanent_energy_beverage'){     
                max_items = Uploader.max_permanent_energy_beverage;
            }else if($group == 'monster_display'){     
                max_items = Uploader.max_monster_display;
            }else if($group == 'monster_claw_sticker'){     
                max_items = Uploader.max_monster_claw_sticker;
            }else if($group == 'npd'){     
                max_items = Uploader.max_npd;
            }else if($group == 'hamilton_npd'){     
                max_items = Uploader.max_hamilton_npd;
            }else if($group == 'coolers_single'){     
                max_items = Uploader.max_coolers_single;
            }else if($group == 'prowler_sticker'){     
                max_items = Uploader.max_prowler_sticker;
            }





            if($('.uploaded-files-group-list[data-group="'+$group+'"] .uploaded-files-group-row').length/2 < max_items){
                $('.uploaded-files-group-list[data-group="'+$group+'"] .add-row').show();
            }
            if(Uploader.canUploadAlbum() ){
                $('.steps-navigation .btn-nav').removeClass('btn-disabled');
                $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'removeTagsRow,');
            }
            var $theTagsForm = $(".uploaded_image_tags."+$group+"_tags");       
            var step = $theTagsForm.data('step');
            if($theTagsForm.parsley().isValid()){ 
                Uploader.stepsStatus(step,true);
            }else{
                Uploader.stepsStatus(step,false);                    
            }     
            $theTagsForm.parsley().reset();
            Uploader.openMobileNextStep();

        },
        getImagePlaceHolder:function($group,$position,$required ){ 
            return `<div class="upload-placeholder-item ${$required}" onclick="Uploader.uploadImage($(this));" data-group="${$group}" data-position="${$position}">
                        <svg class="pluss-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 10H10V16H6V10H0V6H6V0H10V6H16V10Z" fill="white"></path></svg>
                    </div>`;
        },
        
        infoModal:function($this,modal){  
            var data = Object.assign({}, Uploader.data.general);
            if( typeof modal != 'undefined' ){
                 data.partial = 'upload.infoModals.'+modal+'';             
                openPartialModal($this, data);   
            }
           
        },
        changeActiveStep:function(step){ 
            $('.uploaded-files-group').removeClass('active');
            $('.uploaded-files-group[data-step="'+step+'"]').addClass('active');

            $('.uploaded_image_tags').hide();
            $('.uploaded_image_tags[data-step="'+step+'"]').show(); 
            Uploader.currrentStep  = step;  
        },

        steps:function(step){  
            var prevStep = Uploader.currrentStep;
            var valid    = false;
            if(step !== Uploader.currrentStep){

                if(step == 1){                                   
                    if($('.channelLocationModal').length==0){
                        var data = Object.assign({}, Uploader.data.general);
                        data.partial = 'upload.tags.channelLocationModal'; 
                        openPartialModal(null, data);
                    }
                    Uploader.currrentStep  = step;
                    valid = true;
                }

                if( Uploader.allSteps.includes(Uploader.currrentStep) ){
                    Uploader.saveImageTags();
                }

                if(!Uploader.allSteps.includes(Uploader.currrentStep) || step < Uploader.currrentStep){    
                    Uploader.changeActiveStep(step);                   
                    valid = true;

                }else{ 

                    if( Uploader.allSteps.includes(Uploader.currrentStep) ){  


                            $( '.uploaded-files-group.active .upload-placeholder-item:not(.not-required):not(.with-image)' ).addClass('error');
                                var $theTagsForm = $( '.uploaded_image_tags[ data-step="'+Uploader.currrentStep+'" ]' );
                                var $validation = $theTagsForm.parsley().validate(); 
                                
                                if ( $validation && $( '.uploaded-files-group.active .upload-placeholder-item:not(.with-image):not(.not-required)' ).length == 0 ) {                            
                                   
                                    Uploader.stepsStatus(Uploader.currrentStep,true);
                                    $('.uploaded-files-group').removeClass('active');
                                    $('.uploaded-files-group[data-step="'+step+'"]').addClass('active');

                                    $('.uploaded_image_tags').hide();
                                    $('.uploaded_image_tags[data-step="'+step+'"]').show(); 
                                    Uploader.currrentStep  = step;   
                                    valid = true;   
                                }                          
                        
                    }else{
                        Uploader.changeActiveStep(step);                   
                        valid = true;
                    }     

                }
            }

            if(prevStep !== step && valid){
                $('.upload-section .steps-navigation ul li').removeClass('active');
                for(var i =1; i <= step; i++){
                    $('.upload-section .steps-navigation ul li[data-step="'+i+'"]').addClass('active');
                }
            }

            if(step ==Uploader.allSteps[ Uploader.allSteps.length - 1]){
                $('.mobile-step-nav .btn-nav .item-value').html( $('.mobile-step-nav .btn-nav').data('label-submit'));
            }else{
                $('.mobile-step-nav .btn-nav .item-value').html( $('.mobile-step-nav .btn-nav').data('label'));
            }

            if(Uploader.canUploadAlbum()){
                $('.steps-navigation .btn-nav').removeClass('btn-disabled');
                $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'steps,');
            }else{
                $('.steps-navigation .btn-nav').addClass('btn-disabled'); 
                $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'steps,');
            }

            Uploader.openMobileNextStep();
            return valid; 
        },

        nextStep:function($this){    
            var moved = false;
            if(Uploader.formSteps.includes(Uploader.currrentStep) ){   
                if(Uploader.currrentStep==  Uploader.allSteps[ Uploader.allSteps.length - 1]){
                    moved = Uploader.preparePreview($this);
                }else{
                    moved = Uploader.steps(Uploader.currrentStep + 1);
                }
            }
            Uploader.openMobileNextStep();
        },
        openDescriptionModal:function($this){    

            if(jQuery.isEmptyObject( Uploader.data.general ) || !Uploader.data.general ){
                Uploader.steps(1);  

            }else{                
                var data = Object.assign({}, Uploader.data.general);
                data.partial = 'upload.tags.submissionDetailsModal'; 
                openPartialModal($this, data, function(){
                    $('.submissionDetailsModal textarea[name="details"]').on('input',function(){
                        Uploader.data.general.details = $(this).val();
                    });            
                }); 
            }
                    
        },

        saveImageTags:function() { 

            var $activeGroup = $(".uploaded-files-group.active").data('group');      
            var $theTagsForm = $(".uploaded_image_tags."+$activeGroup+"_tags");
            var $tags        = $theTagsForm.serializeArray();                 
            let withData = false;
            if($activeGroup == 'product_display'){
                if(Uploader.data.images.product_display.length>0){
                    Uploader.data.images.product_display.map( function(item){
                        item.data = $tags;
                    });
                    withData = true;
                }
            }
            if($activeGroup == 'secondary_display'){ 
                if(Uploader.data.images.secondary_display.length>0){
                    for (var i = 0; i < Uploader.data.images.secondary_display.length; i++) {
                        Uploader.data.images.secondary_display[i].data = [];
                        index = 1;
                        if(i>1){
                            if(i%2 == 0){
                                index = (i/2) +1;                             
                            }else{
                                index = ((i-1)/2)+1;
                            }
                        }              
                        $tags.map( item => {
                            if(item.name.includes("["+index+"]")){
                                Uploader.data.images.secondary_display[i].data.push({
                                    name: item.name.replace('['+index+'][]', ''), 
                                    value: item.value
                                });
                            }	
                        });                          
                    }
                    withData = true;
                }
            }  

            if($activeGroup == 'stickers'){   
                if(Uploader.data.images.stickers.length>0){                
                    for (var k = 0; k < Uploader.data.images.stickers.length; k++) {        
                        Uploader.data.images.stickers[k].data = [];
                        $tags.map( item => {
                            if(item.name.includes("["+(k+1)+"]")){
                                Uploader.data.images.stickers[k].data.push({
                                    name: item.name.replace('['+(k+1)+'][]', ''), 
                                    value: item.value
                                });
                            }	
                        });                         
                    }
                    withData = true;
                }
            }

             if($activeGroup == 'videos'){   
                if(Uploader.data.images.videos.length>0){                
                    for (var k = 0; k < Uploader.data.images.videos.length; k++) {        
                        Uploader.data.images.videos[k].data = [];
                        $tags.map( item => {
                            if(item.name.includes("["+(k+1)+"]")){
                                Uploader.data.images.videos[k].data.push({
                                    name: item.name.replace('['+(k+1)+'][]', ''), 
                                    value: item.value
                                });
                            }   
                        });                         
                    }
                    withData = true;
                }
            }


             if($activeGroup == 'sticker_boxes'){   
                if(Uploader.data.images.sticker_boxes.length>0){                
                    for (var k = 0; k < Uploader.data.images.sticker_boxes.length; k++) {        
                        Uploader.data.images.sticker_boxes[k].data = [];
                        $tags.map( item => {
                            if(item.name.includes("["+(k+1)+"]")){
                                Uploader.data.images.sticker_boxes[k].data.push({
                                    name: item.name.replace('['+(k+1)+'][]', ''), 
                                    value: item.value
                                });
                            }   
                        });                         
                    }
                    withData = true;
                }
            }

             if($activeGroup == 'coolers_single'){   
                if(Uploader.data.images.coolers_single.length>0){                
                    for (var k = 0; k < Uploader.data.images.coolers_single.length; k++) {        
                        Uploader.data.images.coolers_single[k].data = [];
                        $tags.map( item => {
                            if(item.name.includes("["+(k+1)+"]")){
                                Uploader.data.images.coolers_single[k].data.push({
                                    name: item.name.replace('['+(k+1)+'][]', ''), 
                                    value: item.value
                                });
                            }   
                        });                         
                    }
                    withData = true;
                }
            }

            


            if($activeGroup == 'instant_win'){   
                if(Uploader.data.images.instant_win.length>0){                
                    for (var k = 0; k < Uploader.data.images.instant_win.length; k++) {        
                        Uploader.data.images.instant_win[k].data = [];
                        $tags.map( item => {
                            if(item.name.includes("["+(k+1)+"]")){
                                Uploader.data.images.instant_win[k].data.push({
                                    name: item.name.replace('['+(k+1)+'][]', ''), 
                                    value: item.value
                                });
                            }   
                        });                         
                    }
                    withData = true;
                }
            }


            if($activeGroup == 'wow_displays'){   
                if(Uploader.data.images.wow_displays.length>0){                
                    for (var k = 0; k < Uploader.data.images.wow_displays.length; k++) {        
                        Uploader.data.images.wow_displays[k].data = [];
                        $tags.map( item => {
                            if(item.name.includes("["+(k+1)+"]")){
                                Uploader.data.images.wow_displays[k].data.push({
                                    name: item.name.replace('['+(k+1)+'][]', ''), 
                                    value: item.value
                                });
                            }   
                        });                         
                    }
                    withData = true;
                }
            }

             if($activeGroup == 'coolers'){   
                if(Uploader.data.images.coolers.length>0){
                    for (var i = 0; i < Uploader.data.images.coolers.length; i++) {
                        Uploader.data.images.coolers[i].data = [];
                        index = 1;
                        if(i>1){
                            if(i%2 == 0){
                                index = (i/2) +1;                             
                            }else{
                                index = ((i-1)/2)+1;
                            }
                        }              
                        $tags.map( item => {
                            if(item.name.includes("["+index+"]")){
                                Uploader.data.images.coolers[i].data.push({
                                    name: item.name.replace('['+index+'][]', ''), 
                                    value: item.value
                                });
                            }   
                        });                          
                    }
                    withData = true;
                }
            }


            if($activeGroup == 'monster_metal_rack'){   
                if(Uploader.data.images.monster_metal_rack.length>0){
                    for (var i = 0; i < Uploader.data.images.monster_metal_rack.length; i++) {
                        Uploader.data.images.monster_metal_rack[i].data = [];
                        index = 1;
                        if(i>1){
                            if(i%2 == 0){
                                index = (i/2) +1;                             
                            }else{
                                index = ((i-1)/2)+1;
                            }
                        }              
                        $tags.map( item => {
                            if(item.name.includes("["+index+"]")){
                                Uploader.data.images.monster_metal_rack[i].data.push({
                                    name: item.name.replace('['+index+'][]', ''), 
                                    value: item.value
                                });
                            }   
                        });                          
                    }
                    withData = true;
                }
            }


            if($activeGroup == 'permanent_energy_beverage'){   
                if(Uploader.data.images.permanent_energy_beverage.length>0){
                    for (var i = 0; i < Uploader.data.images.permanent_energy_beverage.length; i++) {
                        Uploader.data.images.permanent_energy_beverage[i].data = [];
                        index = 1;
                        if(i>1){
                            if(i%2 == 0){
                                index = (i/2) +1;                             
                            }else{
                                index = ((i-1)/2)+1;
                            }
                        }              
                        $tags.map( item => {
                            if(item.name.includes("["+index+"]")){
                                Uploader.data.images.permanent_energy_beverage[i].data.push({
                                    name: item.name.replace('['+index+'][]', ''), 
                                    value: item.value
                                });
                            }   
                        });                          
                    }
                    withData = true;
                }
            }

            if($activeGroup == 'monster_display'){   
                if(Uploader.data.images.monster_display.length>0){
                    for (var i = 0; i < Uploader.data.images.monster_display.length; i++) {
                        Uploader.data.images.monster_display[i].data = [];
                        index = 1;
                        if(i>1){
                            if(i%2 == 0){
                                index = (i/2) +1;                             
                            }else{
                                index = ((i-1)/2)+1;
                            }
                        }              
                        $tags.map( item => {
                            if(item.name.includes("["+index+"]")){
                                Uploader.data.images.monster_display[i].data.push({
                                    name: item.name.replace('['+index+'][]', ''), 
                                    value: item.value
                                });
                            }   
                        });                          
                    }
                    withData = true;
                }
            }


             if($activeGroup == 'monster_claw_sticker'){   
                if(Uploader.data.images.monster_claw_sticker.length>0){                
                    for (var k = 0; k < Uploader.data.images.monster_claw_sticker.length; k++) {        
                        Uploader.data.images.monster_claw_sticker[k].data = [];
                        $tags.map( item => {
                            if(item.name.includes("["+(k+1)+"]")){
                                Uploader.data.images.monster_claw_sticker[k].data.push({
                                    name: item.name.replace('['+(k+1)+'][]', ''), 
                                    value: item.value
                                });
                            }   
                        });                         
                    }
                    withData = true;
                }
            }


             if($activeGroup == 'npd'){   
                if(Uploader.data.images.npd.length>0){                
                    for (var k = 0; k < Uploader.data.images.npd.length; k++) {        
                        Uploader.data.images.npd[k].data = [];
                        $tags.map( item => {
                            if(item.name.includes("["+(k+1)+"]")){
                                Uploader.data.images.npd[k].data.push({
                                    name: item.name.replace('['+(k+1)+'][]', ''), 
                                    value: item.value
                                });
                            }   
                        });                         
                    }
                    withData = true;
                }
            }


            if($activeGroup == 'hamilton_npd'){   
                if(Uploader.data.images.hamilton_npd.length>0){                
                    for (var k = 0; k < Uploader.data.images.hamilton_npd.length; k++) {        
                        Uploader.data.images.hamilton_npd[k].data = [];
                        $tags.map( item => {
                            if(item.name.includes("["+(k+1)+"]")){
                                Uploader.data.images.hamilton_npd[k].data.push({
                                    name: item.name.replace('['+(k+1)+'][]', ''), 
                                    value: item.value
                                });
                            }   
                        });                         
                    }
                    withData = true;
                }
            }

             if($activeGroup == 'prowler_sticker'){   
                if(Uploader.data.images.prowler_sticker.length>0){                
                    for (var k = 0; k < Uploader.data.images.prowler_sticker.length; k++) {        
                        Uploader.data.images.prowler_sticker[k].data = [];
                        $tags.map( item => {
                            if(item.name.includes("["+(k+1)+"]")){
                                Uploader.data.images.prowler_sticker[k].data.push({
                                    name: item.name.replace('['+(k+1)+'][]', ''), 
                                    value: item.value
                                });
                            }   
                        });                         
                    }
                    withData = true;
                }
            }



            


            if(Uploader.canUploadAlbum()){
                $('.steps-navigation .btn-nav').removeClass('btn-disabled');

            }else{
                $('.steps-navigation .btn-nav').addClass('btn-disabled');  
            }
            return withData;

        },
        canUploadAlbum:function() {
            var canUploadAlbum = false;

            if( Uploader.data.images.product_display.length > 0 || 
                (Uploader.data.images.secondary_display.length > 0  || [101,11].includes(Uploader.employeeCountry) ) ||
                Uploader.data.images.stickers.length > 0  ||
                Uploader.data.images.videos.length > 0 ||
                Uploader.data.images.sticker_boxes.length > 0 ||
                Uploader.data.images.coolers_single.length > 0 ||
                Uploader.data.images.instant_win.length > 0 ||
                Uploader.data.images.wow_displays.length > 0 ||
                Uploader.data.images.monster_metal_rack.length > 0 ||
                Uploader.data.images.permanent_energy_beverage.length > 0 ||
                Uploader.data.images.monster_display.length > 0 ||
                Uploader.data.images.monster_claw_sticker.length > 0 ||
                Uploader.data.images.npd.length > 0 ||
                Uploader.data.images.hamilton_npd.length > 0 ||
                Uploader.data.images.prowler_sticker.length > 0 ||
                Uploader.data.images.coolers.length > 0){
                  



                canUploadAlbum = true;

                if(Uploader.data.images.product_display.length > 0){
                    Uploader.data.images.product_display.map( item => {
                        if(typeof item.data === 'undefined' || !item.data){
                            canUploadAlbum = false;
                        }
                    });  
                }

                if(![101,11].includes(Uploader.employeeCountry)){
                    Uploader.data.images.secondary_display.map( item => {
                        if(typeof item.data === 'undefined' || !item.data){
                            canUploadAlbum = false;
                        } 
                    });
                }

                Uploader.data.images.stickers.map( item => {
                    if(typeof item.data === 'undefined' || !item.data){
                        canUploadAlbum = false;
                    }
                });  

                if( $('.col-bottom-left .uploaded-files-group[data-group="stickers"] .upload-placeholder-item:not(.not-required):not(.with-image)' ).length > 0 ){   
                    canUploadAlbum = false;                   
                }

                 if( $('.col-bottom-left .uploaded-files-group[data-group="videos"] .upload-placeholder-item:not(.not-required):not(.with-image)' ).length > 0 ){   
                    canUploadAlbum = false;                   
                }

                 if( $('.col-bottom-left .uploaded-files-group[data-group="sticker_boxes"] .upload-placeholder-item:not(.not-required):not(.with-image)' ).length > 0 ){   
                    canUploadAlbum = false;                   
                }
                if( $('.col-bottom-left .uploaded-files-group[data-group="coolers_single"] .upload-placeholder-item:not(.not-required):not(.with-image)' ).length > 0 ){   
                    canUploadAlbum = false;                   
                }

                  if( $('.col-bottom-left .uploaded-files-group[data-group="instant_win"] .upload-placeholder-item:not(.not-required):not(.with-image)' ).length > 0 ){   
                    canUploadAlbum = false;                   
                }

                if( $('.col-bottom-left .uploaded-files-group[data-group="wow_displays"] .upload-placeholder-item:not(.not-required):not(.with-image)' ).length > 0 ){   
                    canUploadAlbum = false;                   
                }

                if( $('.col-bottom-left .uploaded-files-group[data-group="monster_metal_rack"] .upload-placeholder-item:not(.not-required):not(.with-image)' ).length > 0 ){   
                    canUploadAlbum = false;                   
                }

                if( $('.col-bottom-left .uploaded-files-group[data-group="permanent_energy_beverage"] .upload-placeholder-item:not(.not-required):not(.with-image)' ).length > 0 ){   
                    canUploadAlbum = false;                   
                }

                 if( $('.col-bottom-left .uploaded-files-group[data-group="monster_display"] .upload-placeholder-item:not(.not-required):not(.with-image)' ).length > 0 ){   
                    canUploadAlbum = false;                   
                }
                
                if( $('.col-bottom-left .uploaded-files-group[data-group="monster_claw_sticker"] .upload-placeholder-item:not(.not-required):not(.with-image)' ).length > 0 ){   
                    canUploadAlbum = false;                   
                }

                if( $('.col-bottom-left .uploaded-files-group[data-group="npd"] .upload-placeholder-item:not(.not-required):not(.with-image)' ).length > 0 ){   
                    canUploadAlbum = false;                   
                }

                  if( $('.col-bottom-left .uploaded-files-group[data-group="hamilton_npd"] .upload-placeholder-item:not(.not-required):not(.with-image)' ).length > 0 ){   
                    canUploadAlbum = false;                   
                }

                if( $('.col-bottom-left .uploaded-files-group[data-group="prowler_sticker"] .upload-placeholder-item:not(.not-required):not(.with-image)' ).length > 0 ){   
                    canUploadAlbum = false;                   
                }


                 if( $('.col-bottom-left .uploaded-files-group[data-group="coolers"] .upload-placeholder-item:not(.not-required):not(.with-image)' ).length > 0 ){   
                    canUploadAlbum = false;                   
                }
                
                if( $('.col-bottom-left .uploaded-files-group[data-group="product_display"] .upload-placeholder-item:not(.not-required):not(.with-image)' ).length > 0 && 
                    $('.col-bottom-left .uploaded-files-group[data-group="product_display"] .upload-placeholder-item.with-image' ).length > 0 ){   
                    canUploadAlbum = false;
                }

                if( $('.col-bottom-left .uploaded-files-group[data-group="secondary_display"] .upload-placeholder-item:not(.not-required):not(.with-image)' ).length > 0 && 
                    $('.col-bottom-left .uploaded-files-group[data-group="secondary_display"] .upload-placeholder-item.with-image' ).length > 0 ){   
                    canUploadAlbum = false;
                }

                if(![101,11].includes(Uploader.employeeCountry)){
                    if( $('.col-bottom-left .uploaded-files-group[data-group="secondary_display"] .upload-placeholder-item:not(.not-required):not(.with-image)' ).length > 0 ){   
                        canUploadAlbum = false;
                    }
                }



            }
            return canUploadAlbum;
        },         
        saveStep1tags:function() {               
            var $theTagsForm = $(".step-1-form");      
            var $validation = $theTagsForm.parsley().validate();       
            var $productDisplayTagsPartial = $('.product_display_tags .partial');        
            if ($validation) { 
                var $tags = $theTagsForm.serializeArray();
                for(var k in $tags){
                    Uploader.data.general[$tags[k].name] = $tags[k].value;
                    if($tags[k].name == 'region'){
                        $('.product_display_tags .partial').data('region',$tags[k].value);
                       
                    }
                    if($tags[k].name == 'album_type'){
                        $('.selected-album-type').html($tags[k].value);
                    }                
                }
                $('.channelLocationModal').modal('hide');
                $('.upload-section .steps-navigation ul li[data-step="1"]').addClass('completed');    

                if(Uploader.data.images.product_display.length>0){
                    
                    let selectedSKUsArray = [];
                    let selectedNPDsArray = [];

                    Uploader.data.images.product_display.map( function(image , index) {
                        if(index == 0){
                            $productDisplayTagsPartial.data('image_before', image.thumb);                                
                        }
                        if(index == 1){
                            $productDisplayTagsPartial.data('image_after', image.thumb);    
                        }
                        
                        if(typeof image.data !=='undefined' && image.data.length>0){
                            image.data.map( function(tag) {                                
                                if(tag.name === 'sku' && !selectedSKUsArray.includes(tag.value)){
                                    selectedSKUsArray.push(tag.value)
                                }
                                if(tag.name === 'npd' && !selectedNPDsArray.includes(tag.value)){
                                    selectedNPDsArray.push(tag.value)
                                }
                            })
                        }                                            
                    });

                    if(selectedSKUsArray.length>0){
                        $productDisplayTagsPartial.data('selected_sku', selectedSKUsArray.join(','));    
                    }
                    if(selectedNPDsArray.length>0){
                        $productDisplayTagsPartial.data('selected_npd', selectedNPDsArray.join(','))
                    }
                }
                load_partial($productDisplayTagsPartial); 
                Uploader.steps(2);
            }
        }, 
         getExtension:function(filename){
            var parts = filename.split('.');
            return parts[parts.length - 1];
        },
        isVideo:function(filename){
            var ext = Uploader.getExtension(filename);
            switch (ext.toLowerCase()) {
                case 'm4v':
                case 'avi':
                case 'mpg':
                case 'mp4':
                case 'mov':
                  // etc
                  return true;
            }
            return false;
        },     
        inlineUploader:function(target){  

            if($('#'+target).data('mimetypes')!=='' ){
               $mime_types=  $('#'+target).data('mimetypes');
            }else{
                $mime_types=  [{title : "Images", extensions : "jpg,jpeg,png"}];
            }

            Uploader.uploader = new plupload.Uploader({
                runtimes        : 'html5,flash,silverlight,browserplus',
                browse_button   : target + '-pickfiles',
                container       : target + '-container',
                drop_element    : target + '-dropzone',
                url             : '/upload',
                headers:{
                    'X-CSRF-TOKEN':$('meta[name="csrf-token"]').attr('content')
                },
                filters : {
                    max_file_size : '1024mb',
                    mime_types: $mime_types
                }
            });
            var uploader = Uploader.uploader;          
            
            $('.upload-placeholder-item').click(function(e) {
                uploader.start();
                e.preventDefault();
            });
            
            uploader.init();

            uploader.bind('FilesAdded', function(up, files) {
                var error_shown = false;
                $.each(files, function(i, file) {         

                    var total_uploads = Uploader.data.images.product_display.length +
                        Uploader.data.images.product_display.length +
                        Uploader.data.images.product_display.length;
                    if(total_uploads < 50){                   
                        $progress = `<div class="loader"><div class="loaderBar"></div></div>`;
                        $('.upload-placeholder-item[data-group="'+Uploader.selectedSpot.group+'"][data-position="'+Uploader.selectedSpot.position+'"]').append($progress);
                        $('.upload-placeholder-item').addClass('disabled');
                        $('.upload-placeholder-item[data-group="'+Uploader.selectedSpot.group+'"][data-position="'+Uploader.selectedSpot.position+'"]').removeClass('disabled');
                    }else{
                        up.removeFile(file);
                        if(!error_shown){
                            error_shown = true;
                            actionResponseModal( 'Only 50 files per upload !' ,'error');                  
                        }                   
                    }                
                });
                up.refresh();
                uploader.start();            
            });
            uploader.bind('QueueChanged', function(up, files){
                Uploader.files_remaining = uploader.files.length;
            });

            uploader.bind('FileUploaded', function(up, file, ee) {
                var server_response = JSON.parse(ee.response);
                var id = uniqid(server_response.path);   
                var img_src   =  server_response.path;                        
                var img_thumb =  '/'+server_response.path+'?width=450&height=450'; 
                if(Uploader.isVideo(img_src)){
                    img_thumb =  '/assets/frontend/monster/img/video-placeholder.jpg';    
                }                       
                var obj = {
                    fild_id : file.id, 
                    id      : id,
                    thumb   : img_thumb,
                    src     : img_src, 
                };
                Uploader.fileUploaded(obj); 

                $('.upload-placeholder-item[data-group="'+Uploader.selectedSpot.group+'"][data-position="'+Uploader.selectedSpot.position+'"] .loader').fadeOut(200,function(){
                    $('.upload-placeholder-item[data-group="'+Uploader.selectedSpot.group+'"][data-position="'+Uploader.selectedSpot.position+'"] .loader').remove();
                    $('.upload-placeholder-item').removeClass('disabled');
                });




                if( $('.col-bottom-left .uploaded-files-group.active .upload-placeholder-item:not(.not-required):not(.with-image)' ).length == 0 ){                
                    var step = $( '.col-bottom-left .uploaded-files-group.active').data('step');                
                    if( $('.uploaded_image_tags.'+Uploader.selectedSpot.group+'_tags').parsley().isValid() ){                        
                        Uploader.stepsStatus(step,true);
                    }else{                        
                        Uploader.stepsStatus(step,false);
                    }
                }

                if( $('.col-bottom-left .uploaded-files-group.active .upload-placeholder-item.with-image' ).length >  0 ){ 
                   
                    $('.uploaded_image_tags.'+Uploader.selectedSpot.group+'_tags').find('input:not(.force-not-required)').each(function(){
                        $(this).prop('required', true);
                    });
                      $('.upload-placeholder-item[data-group="'+Uploader.selectedSpot.group+'"][data-position="'+Uploader.selectedSpot.position+'"]').closest('.uploaded-files-group-row').find('.upload-placeholder-item.not-required').removeClass('not-required').addClass('required');
                }

                $.ajax({url: obj.thumb,type: 'GET'});

                if(Uploader.selectedSpot.group == 'stickers'){
                    if( Uploader.canUploadAlbum() ){
                        $('.steps-navigation .btn-nav').removeClass('btn-disabled');
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }else{
                        $('.steps-navigation .btn-nav').addClass('btn-disabled');  
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }
                }
                
                if(Uploader.selectedSpot.group == 'videos'){
                    if( Uploader.canUploadAlbum() ){
                        $('.steps-navigation .btn-nav').removeClass('btn-disabled');
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }else{
                        $('.steps-navigation .btn-nav').addClass('btn-disabled');  
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }
                }

                if(Uploader.selectedSpot.group == 'sticker_boxes'){
                    if( Uploader.canUploadAlbum() ){
                        $('.steps-navigation .btn-nav').removeClass('btn-disabled');
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }else{
                        $('.steps-navigation .btn-nav').addClass('btn-disabled');  
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }
                }


                if(Uploader.selectedSpot.group == 'coolers_single'){
                    if( Uploader.canUploadAlbum() ){
                        $('.steps-navigation .btn-nav').removeClass('btn-disabled');
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }else{
                        $('.steps-navigation .btn-nav').addClass('btn-disabled');  
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }
                }
                 if(Uploader.selectedSpot.group == 'instant_win'){
                    if( Uploader.canUploadAlbum() ){
                        $('.steps-navigation .btn-nav').removeClass('btn-disabled');
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }else{
                        $('.steps-navigation .btn-nav').addClass('btn-disabled');  
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }
                }

                if(Uploader.selectedSpot.group == 'wow_displays'){
                    if( Uploader.canUploadAlbum() ){
                        $('.steps-navigation .btn-nav').removeClass('btn-disabled');
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }else{
                        $('.steps-navigation .btn-nav').addClass('btn-disabled');  
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }
                }

                if(Uploader.selectedSpot.group == 'coolers'){
                    if( Uploader.canUploadAlbum() ){
                        $('.steps-navigation .btn-nav').removeClass('btn-disabled');
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }else{
                        $('.steps-navigation .btn-nav').addClass('btn-disabled');  
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }
                }

                 if(Uploader.selectedSpot.group == 'monster_metal_rack'){
                    if( Uploader.canUploadAlbum() ){
                        $('.steps-navigation .btn-nav').removeClass('btn-disabled');
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }else{
                        $('.steps-navigation .btn-nav').addClass('btn-disabled');  
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }
                }

                 if(Uploader.selectedSpot.group == 'permanent_energy_beverage'){
                    if( Uploader.canUploadAlbum() ){
                        $('.steps-navigation .btn-nav').removeClass('btn-disabled');
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }else{
                        $('.steps-navigation .btn-nav').addClass('btn-disabled');  
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }
                }

                 if(Uploader.selectedSpot.group == 'monster_display'){
                    if( Uploader.canUploadAlbum() ){
                        $('.steps-navigation .btn-nav').removeClass('btn-disabled');
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }else{
                        $('.steps-navigation .btn-nav').addClass('btn-disabled');  
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }
                }


                 if(Uploader.selectedSpot.group == 'monster_claw_sticker'){
                    if( Uploader.canUploadAlbum() ){
                        $('.steps-navigation .btn-nav').removeClass('btn-disabled');
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }else{
                        $('.steps-navigation .btn-nav').addClass('btn-disabled');  
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }
                }

                 if(Uploader.selectedSpot.group == 'npd'){
                    if( Uploader.canUploadAlbum() ){
                        $('.steps-navigation .btn-nav').removeClass('btn-disabled');
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }else{
                        $('.steps-navigation .btn-nav').addClass('btn-disabled');  
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }
                }


                if(Uploader.selectedSpot.group == 'hamilton_npd'){
                    if( Uploader.canUploadAlbum() ){
                        $('.steps-navigation .btn-nav').removeClass('btn-disabled');
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }else{
                        $('.steps-navigation .btn-nav').addClass('btn-disabled');  
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }
                }


                if(Uploader.selectedSpot.group == 'prowler_sticker'){
                    if( Uploader.canUploadAlbum() ){
                        $('.steps-navigation .btn-nav').removeClass('btn-disabled');
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }else{
                        $('.steps-navigation .btn-nav').addClass('btn-disabled');  
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'inlineUploader,');
                    }
                }


                

                
            });

            uploader.bind('Error', function(up, err) {                                  
                up.refresh();
            });
           
            var $theTagsForm = $(".uploaded_image_tags");       
            $theTagsForm.on("input", function() { 
                Uploader.formStatus($(this));
            });

        },
        formStatus:function($this){   
            var $group = $this.data('group');
            var step   = $( '.uploaded-files-group.active').data('step');           
            var $validation = $this.parsley().validate(); 
            if($validation){                 
                if($( '.uploaded-files-group.active .upload-placeholder-item:not(.not-required):not(.with-image)' ).length > 0){
                    $( '.uploaded-files-group.active .upload-placeholder-item:not(.not-required):not(.with-image)' ).addClass('error');
                }else{
                    Uploader.stepsStatus(step,true);
                }
            } else{                    
                Uploader.stepsStatus(step,false)
            }   

          //  if($this.hasClass('stickers_tags')){                               
                if(Uploader.canUploadAlbum() && $validation ){
                    $('.steps-navigation .btn-nav').removeClass('btn-disabled');
                    $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'formStatus,');
                }else{
                    $('.steps-navigation .btn-nav').addClass('btn-disabled'); 
                    $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'formStatus,'); 
                }
           // }
            Uploader.openMobileNextStep();
            $this.parsley().reset();            
        },
        
        openMobileNextStep : function (){


                if(Uploader.allSteps.includes(Uploader.currrentStep)){
                    if(Uploader.currrentStep ==Uploader.allSteps[ Uploader.allSteps.length - 1] && Uploader.canUploadAlbum()){
                        $('.mobile-step-nav .btn-nav').removeClass('btn-disabled'); 
                        $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'openMobileNextStep,');

                    }else{                    
                        var $form = $('.uploaded_image_tags[data-step="'+Uploader.currrentStep+'"]');                      
                        var $validation = $form.parsley().validate(); 
                        //$form.parsley().reset();  
                        if($validation){ 
                            if($( '.uploaded-files-group.active .upload-placeholder-item:not(.not-required):not(.with-image)' ).length > 0){
                                $('.mobile-step-nav .btn-nav').addClass('btn-disabled');  
                                $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'openMobileNextStep,');
                            }else{
                                $('.mobile-step-nav .btn-nav').removeClass('btn-disabled');
                                $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'openMobileNextStep,');  
                            }
                        } else{                    
                            $('.mobile-step-nav .btn-nav').addClass('btn-disabled');  
                            $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'openMobileNextStep,');
                        }
                    }
                }
            
        },
        stepsStatus:function(step,completed){ 
            if(completed){
                const withData = Uploader.saveImageTags();
                if(withData){
                    $('.upload-section .steps-navigation ul li[data-step="'+step+'"]').addClass('completed');
                }else{
                    $('.upload-section .steps-navigation ul li[data-step="'+step+'"]').removeClass('completed');    
                }
            }else{
                $('.upload-section .steps-navigation ul li[data-step="'+step+'"]').removeClass('completed');
            }
        },
        fileUploaded:function(obj){       
            var selectedSpotEl = $('.upload-placeholder-item[data-group="'+Uploader.selectedSpot.group+'"][data-position="'+Uploader.selectedSpot.position+'"]');                     
            selectedSpotEl.removeClass('error');
            selectedSpotEl.css("background-image", "url(" + obj.thumb + ")").addClass('with-image');
            Uploader.data.images[Uploader.selectedSpot.group][Uploader.selectedSpot.position] = obj;
            Uploader.openMobileNextStep();
        },
        gotoUpload:function(){  
            $('.upload-view').hide();
            $('.upload-view[data-view="upload"]').show();    
        },
        preparePreview:function(){           
            
            if(jQuery.isEmptyObject( Uploader.data.general ) || !Uploader.data.general ){
                Uploader.steps(1);  
            }else{
                if(Uploader.canUploadAlbum() ){
                    $('.submissionDetailsModal').modal('hide');        
                    const $previewImages = $('.upload-view[data-view="preview"] .preview-images');
                    $previewImages.empty();
                    for (var i = 0; i < Uploader.data.images.product_display.length; i++) {
                        if(i%2 != 0){
                            $previewImages.append(Uploader.addPreviewRow('product_display',[
                                Uploader.data.images.product_display[i-1],
                                Uploader.data.images.product_display[i]
                            ]));
                        }             
                    }
                    for (var i = 0; i < Uploader.data.images.secondary_display.length; i++) {
                        if(i%2 != 0){
                            $previewImages.append(Uploader.addPreviewRow('secondary_display',[
                                Uploader.data.images.secondary_display[i-1],
                                Uploader.data.images.secondary_display[i]
                            ]));
                        }             
                    }
                    for (var i = 0; i < Uploader.data.images.stickers.length; i++) {
                        $previewImages.append( Uploader.addPreviewRow('stickers',Uploader.data.images.stickers[i]));
                    }    

                     for (var i = 0; i < Uploader.data.images.videos.length; i++) {
                        $previewImages.append( Uploader.addPreviewRow('videos',Uploader.data.images.videos[i]));
                    } 

                     for (var i = 0; i < Uploader.data.images.sticker_boxes.length; i++) {
                        $previewImages.append( Uploader.addPreviewRow('sticker_boxes',Uploader.data.images.sticker_boxes[i]));
                    } 

                     for (var i = 0; i < Uploader.data.images.coolers_single.length; i++) {
                        $previewImages.append( Uploader.addPreviewRow('coolers_single',Uploader.data.images.coolers_single[i]));
                    } 


                     for (var i = 0; i < Uploader.data.images.instant_win.length; i++) {
                        $previewImages.append( Uploader.addPreviewRow('instant_win',Uploader.data.images.instant_win[i]));
                    } 

                     for (var i = 0; i < Uploader.data.images.wow_displays.length; i++) {
                        $previewImages.append( Uploader.addPreviewRow('wow_displays',Uploader.data.images.wow_displays[i]));
                    } 

                     for (var i = 0; i < Uploader.data.images.coolers.length; i++) {
                        if(i%2 != 0){
                            $previewImages.append(Uploader.addPreviewRow('coolers',[
                                Uploader.data.images.coolers[i-1],
                                Uploader.data.images.coolers[i]
                            ]));
                        }             
                    }

                    for (var i = 0; i < Uploader.data.images.monster_metal_rack.length; i++) {
                        if(i%2 != 0){
                            $previewImages.append(Uploader.addPreviewRow('monster_metal_rack',[
                                Uploader.data.images.monster_metal_rack[i-1],
                                Uploader.data.images.monster_metal_rack[i]
                            ]));
                        }             
                    }

                    for (var i = 0; i < Uploader.data.images.permanent_energy_beverage.length; i++) {
                        if(i%2 != 0){
                            $previewImages.append(Uploader.addPreviewRow('permanent_energy_beverage',[
                                Uploader.data.images.permanent_energy_beverage[i-1],
                                Uploader.data.images.permanent_energy_beverage[i]
                            ]));
                        }             
                    }

                    for (var i = 0; i < Uploader.data.images.monster_display.length; i++) {
                        if(i%2 != 0){
                            $previewImages.append(Uploader.addPreviewRow('monster_display',[
                                Uploader.data.images.monster_display[i-1],
                                Uploader.data.images.monster_display[i]
                            ]));
                        }             
                    }

                      for (var i = 0; i < Uploader.data.images.monster_claw_sticker.length; i++) {
                        $previewImages.append( Uploader.addPreviewRow('monster_claw_sticker',Uploader.data.images.monster_claw_sticker[i]));
                    } 

                     for (var i = 0; i < Uploader.data.images.npd.length; i++) {
                        $previewImages.append( Uploader.addPreviewRow('npd',Uploader.data.images.npd[i]));
                    } 


                      for (var i = 0; i < Uploader.data.images.hamilton_npd.length; i++) {
                        $previewImages.append( Uploader.addPreviewRow('hamilton_npd',Uploader.data.images.hamilton_npd[i]));
                    } 


                     for (var i = 0; i < Uploader.data.images.prowler_sticker.length; i++) {
                        $previewImages.append( Uploader.addPreviewRow('prowler_sticker',Uploader.data.images.prowler_sticker[i]));
                    } 


                    

                    $('.upload-view').hide();
                    $('.upload-view[data-view="preview"]').show();  
                }else{
                    $('.steps-navigation .btn-nav').addClass('btn-disabled');
                    $('.steps-navigation .btn-nav').attr('touched-from',$('.steps-navigation .btn-nav').attr('touched-from')+'preparePreview,');
                }
            } 
        },

        addPreviewRow:function($group,$item){
            var template = '',label;

            
            if($group == 'secondary_display' || $group == 'product_display' || $group == 'coolers' || $group =='monster_metal_rack'
                || $group =='permanent_energy_beverage' || $group == 'monster_display' ){         
                label = 'Secondary Display';
                if($group == 'product_display'){        
                    label = 'Product Display';                    
                }else  if($group == 'coolers'){        
                    label = 'Coolers';                    
                }else  if($group == 'monster_metal_rack'){        
                    label = 'Monster Metal Rack Placement';                    
                }else  if($group == 'permanent_energy_beverage'){        
                    label = 'Permanent Energy Beverage Section Set Up';                    
                }else  if($group == 'monster_display'){        
                    label = 'Monster Display Placement';                    
                }

                template = `<div class="uploaded-files-group-row col-12 col-sm-6">
                                <div class="d-flex w-100 justify-content-between align-items-center">
                                    <h6 class="text-uppercase no-margin">${label}</h6>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col-6">
                                        <div class="preview-placeholder-item" style="background-image:url(${$item[0].thumb})" > </div>                                    
                                    </div>
                                    <div class="col-6">
                                        <div class="preview-placeholder-item" style="background-image:url(${$item[1].thumb})" ></div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <h6 class="no-margin font-alt-regular text-center font16 subtitle">#BEFORE</h6>
                                    </div>
                                    <div class="col-6">
                                        <h6 class="no-margin font-alt-regular text-center font16 subtitle">#AFTER</h6>
                                    </div>
                                </div>
                            </div>`;
                            
            } else{
                label = $group.replace('_',' ').toUpperCase();  
                 var brand = '';

                 if($group == 'videos'){        
                    label = 'BB Videos & Pics';                    
                }else  if($group == 'monster_claw_sticker'){        
                    label = 'Monster Claw Sticker Placement';                    
                }else  if($group == 'npd'){        
                    label = 'NPD Introduction';                    
                }else  if($group == 'hamilton_npd'){        
                    label = 'Hamilton NPD';                    
                }else  if($group == 'prowler_sticker'){        
                    label = 'Prowler Sticker';                    
                }else  if($group == 'coolers_single'){        
                    label = 'Coolers';                    
                }





                if( $item.data.filter( item => item.name.includes("videos_brand") ).length >0  ){
                     brand = $item.data.filter( item => item.name.includes("videos_brand") );  
                }else if( $item.data.filter( item => item.name.includes("sticker_boxes_brand") ).length >0 ){
                     brand = $item.data.filter( item => item.name.includes("sticker_boxes_brand") );  
                }else if( $item.data.filter( item => item.name.includes("instant_win_brand") ).length >0  ){
                     brand = $item.data.filter( item => item.name.includes("instant_win_brand") );  
                } else if( $item.data.filter( item => item.name.includes("wow_displays_brand") ).length >0 ){
                     brand = $item.data.filter( item => item.name.includes("wow_displays_brand") );  
                }else if( $item.data.filter( item => item.name.includes("monster_claw_sticker_brand") ).length >0 ){
                     brand = $item.data.filter( item => item.name.includes("monster_claw_sticker_brand") );  
                } else if( $item.data.filter( item => item.name.includes("npd_brand") ).length >0 ){
                     brand = $item.data.filter( item => item.name.includes("npd_brand") );  
                } else if( $item.data.filter( item => item.name.includes("hamilton_npd_brand") ).length >0 ){
                     brand = $item.data.filter( item => item.name.includes("hamilton_npd_brand") );  
                } else if( $item.data.filter( item => item.name.includes("prowler_sticker_brand") ).length >0 ){
                     brand = $item.data.filter( item => item.name.includes("prowler_sticker_brand") );  
                }  else  if($item.data.filter( item => item.name.includes("brand") ).length >0 ){
                     brand = $item.data.filter( item => item.name.includes("brand") );   
                }else if( $item.data.filter( item => item.name.includes("coolers_single_brand") ).length >0 ){
                     brand = $item.data.filter( item => item.name.includes("coolers_single_brand") );  
                }
                if(typeof(brand)!=='undefined' && brand.length>0){
                     template = `<div class="uploaded-files-group-row col-6 col-sm-3">
                                <div class="d-flex w-100 justify-content-between align-items-center">
                                    <h6 class="text-uppercase no-margin">${label}</h6>
                                </div>
                                <div class="preview-placeholder-item" style="background-image:url(${$item.thumb})" ></div>  
                                <h6 class="no-margin font-alt-regular text-center font16 subtitle">${brand[0].value}</h6>
                            </div>`;
                }else{
                       template = `<div class="uploaded-files-group-row col-6 col-sm-3">
                                <div class="d-flex w-100 justify-content-between align-items-center">
                                    <h6 class="text-uppercase no-margin">${label}</h6>
                                </div>
                                <div class="preview-placeholder-item" style="background-image:url(${$item.thumb})" ></div>  
                              
                            </div>`;
                }


               
            }
            return template;           
        },

        prepareSubmitted:function(){         
            
            const $submittedTags = $('.upload-view[data-view="submitted"] .submitted-tags');        
            $submittedTags.data(Uploader.data);
            load_partial($submittedTags);

            const $submittedImages = $('.upload-view[data-view="submitted"] .preview-images');
            $submittedImages.empty();
            for (var i = 0; i < Uploader.data.images.product_display.length; i++) {
                if(i%2 != 0){
                    $submittedImages.append(Uploader.addSubmittedRow('product_display',[
                        Uploader.data.images.product_display[i-1],
                        Uploader.data.images.product_display[i]
                    ]));
                }             
            }
            for (var i = 0; i < Uploader.data.images.secondary_display.length; i++) {
                if(i%2 != 0){
                    $submittedImages.append(Uploader.addSubmittedRow('secondary_display',[
                        Uploader.data.images.secondary_display[i-1],
                        Uploader.data.images.secondary_display[i]
                    ]));
                }             
            }
            for (var i = 0; i < Uploader.data.images.stickers.length; i++) {
                $submittedImages.append( Uploader.addSubmittedRow('stickers',Uploader.data.images.stickers[i]));
            }

             for (var i = 0; i < Uploader.data.images.videos.length; i++) {
                $submittedImages.append( Uploader.addSubmittedRow('videos',Uploader.data.images.videos[i]));
            }

             for (var i = 0; i < Uploader.data.images.sticker_boxes.length; i++) {
                $submittedImages.append( Uploader.addSubmittedRow('sticker_boxes',Uploader.data.images.sticker_boxes[i]));
            }

             for (var i = 0; i < Uploader.data.images.coolers_single.length; i++) {
                $submittedImages.append( Uploader.addSubmittedRow('coolers_single',Uploader.data.images.coolers_single[i]));
            }

             for (var i = 0; i < Uploader.data.images.instant_win.length; i++) {
                $submittedImages.append( Uploader.addSubmittedRow('instant_win',Uploader.data.images.instant_win[i]));
            }

             for (var i = 0; i < Uploader.data.images.wow_displays.length; i++) {
                $submittedImages.append( Uploader.addSubmittedRow('wow_displays',Uploader.data.images.wow_displays[i]));
            }

             for (var i = 0; i < Uploader.data.images.coolers.length; i++) {
                if(i%2 != 0){
                    $submittedImages.append(Uploader.addSubmittedRow('coolers',[
                        Uploader.data.images.coolers[i-1],
                        Uploader.data.images.coolers[i]
                    ]));
                }             
            }

             for (var i = 0; i < Uploader.data.images.monster_metal_rack.length; i++) {
                if(i%2 != 0){
                    $submittedImages.append(Uploader.addSubmittedRow('monster_metal_rack',[
                        Uploader.data.images.monster_metal_rack[i-1],
                        Uploader.data.images.monster_metal_rack[i]
                    ]));
                }             
            }

            for (var i = 0; i < Uploader.data.images.permanent_energy_beverage.length; i++) {
                if(i%2 != 0){
                    $submittedImages.append(Uploader.addSubmittedRow('permanent_energy_beverage',[
                        Uploader.data.images.permanent_energy_beverage[i-1],
                        Uploader.data.images.permanent_energy_beverage[i]
                    ]));
                }             
            }

             for (var i = 0; i < Uploader.data.images.monster_display.length; i++) {
                if(i%2 != 0){
                    $submittedImages.append(Uploader.addSubmittedRow('monster_display',[
                        Uploader.data.images.monster_display[i-1],
                        Uploader.data.images.monster_display[i]
                    ]));
                }             
            }

             for (var i = 0; i < Uploader.data.images.monster_claw_sticker.length; i++) {
                $submittedImages.append( Uploader.addSubmittedRow('monster_claw_sticker',Uploader.data.images.monster_claw_sticker[i]));
            }


            for (var i = 0; i < Uploader.data.images.npd.length; i++) {
                $submittedImages.append( Uploader.addSubmittedRow('npd',Uploader.data.images.npd[i]));
            }


             for (var i = 0; i < Uploader.data.images.hamilton_npd.length; i++) {
                $submittedImages.append( Uploader.addSubmittedRow('hamilton_npd',Uploader.data.images.hamilton_npd[i]));
            }

               for (var i = 0; i < Uploader.data.images.prowler_sticker.length; i++) {
                $submittedImages.append( Uploader.addSubmittedRow('prowler_sticker',Uploader.data.images.prowler_sticker[i]));
            }

            

            

            $('.upload-view').hide();
            $('.upload-view[data-view="submitted"]').show();        
        },

        addSubmittedRow:function($group,$item){
            var template = '',label='';
            if($group == 'secondary_display' || $group == 'product_display' || $group == 'coolers' || $group =='monster_metal_rack'
                || $group =='permanent_energy_beverage' || $group == 'monster_display' ){         
                label = 'Secondary Display';
                if($group == 'product_display'){        
                    label = 'Product Display';                    
                }else  if($group == 'coolers'){        
                    label = 'Coolers';                    
                }else  if($group == 'monster_metal_rack'){        
                    label = 'Monster Metal Rack Placement';                    
                }else  if($group == 'permanent_energy_beverage'){        
                    label = 'Permanent Energy Beverage Section Set Up';                    
                }else  if($group == 'monster_display'){        
                    label = 'Monster Display Placement';                    
                }
                template = `<div class="uploaded-files-group-row col-12 col-sm-6 col-lg-4 col-xl-3">
                                <div class="d-flex w-100 justify-content-between align-items-center">
                                    <h6 class="text-uppercase no-margin">${label}</h6>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col-6">
                                        <div class="preview-placeholder-item" style="background-image:url(${$item[0].thumb})" > </div>                                    
                                    </div>
                                    <div class="col-6">
                                        <div class="preview-placeholder-item" style="background-image:url(${$item[1].thumb})" ></div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <h6 class="no-margin font-alt-regular text-center font16 subtitle">#BEFORE</h6>
                                    </div>
                                    <div class="col-6">
                                        <h6 class="no-margin font-alt-regular text-center font16 subtitle">#AFTER</h6>
                                    </div>
                                </div>
                            </div>`;
                            
            }else{
                 label = $group.replace('_',' ').toUpperCase();       
               if($group == 'videos'){        
                    label = 'BB Videos & Pics';                    
                }else  if($group == 'monster_claw_sticker'){        
                    label = 'Monster Claw Sticker Placement';                    
                }else  if($group == 'npd'){        
                    label = 'NPD Introduction';                    
                }else  if($group == 'hamilton_npd'){        
                    label = 'Hamilton NPD';                    
                }else  if($group == 'prowler_sticker'){        
                    label = 'Prowler Sticker';                    
                }else  if($group == 'coolers_single'){        
                    label = 'Coolers';                    
                }



                if( $item.data.filter( item => item.name.includes("videos_brand") ).length >0  ){
                     brand = $item.data.filter( item => item.name.includes("videos_brand") );  
                }else if( $item.data.filter( item => item.name.includes("sticker_boxes_brand") ).length >0 ){
                     brand = $item.data.filter( item => item.name.includes("sticker_boxes_brand") );  
                }else if( $item.data.filter( item => item.name.includes("instant_win_brand") ).length >0  ){
                     brand = $item.data.filter( item => item.name.includes("instant_win_brand") );  
                } else if( $item.data.filter( item => item.name.includes("wow_displays_brand") ).length >0 ){
                     brand = $item.data.filter( item => item.name.includes("wow_displays_brand") );  
                }else if( $item.data.filter( item => item.name.includes("monster_claw_sticker_brand") ).length >0 ){
                     brand = $item.data.filter( item => item.name.includes("monster_claw_sticker_brand") );  
                } else if( $item.data.filter( item => item.name.includes("npd_brand") ).length >0 ){
                     brand = $item.data.filter( item => item.name.includes("npd_brand") );  
                }  else if( $item.data.filter( item => item.name.includes("hamilton_npd_brand") ).length >0 ){
                     brand = $item.data.filter( item => item.name.includes("hamilton_npd_brand") );  
                }  else if( $item.data.filter( item => item.name.includes("prowler_sticker_brand") ).length >0 ){
                     brand = $item.data.filter( item => item.name.includes("prowler_sticker_brand") );  
                } else  if($item.data.filter( item => item.name.includes("brand") ).length >0 ){
                     brand = $item.data.filter( item => item.name.includes("brand") );   
                }else if( $item.data.filter( item => item.name.includes("coolers_single_brand") ).length >0 ){
                     brand = $item.data.filter( item => item.name.includes("coolers_single_brand") );  
                }

                 if(typeof(brand)!=='undefined' && brand.length>0 ){

                        template = `<div class="uploaded-files-group-row col-6 col-sm-3 col-lg-2 col-xl-w-12-5">
                                <div class="d-flex w-100 justify-content-between align-items-center">
                                    <h6 class="text-uppercase no-margin">${label}</h6>
                                </div>
                                <div class="preview-placeholder-item" style="background-image:url(${$item.thumb})" ></div>  
                                <h6 class="no-margin font-alt-regular text-center font16 subtitle">${brand[0].value}</h6>
                            </div>`;
                    }else{
                         template = `<div class="uploaded-files-group-row col-6 col-sm-3 col-lg-2 col-xl-w-12-5">
                                <div class="d-flex w-100 justify-content-between align-items-center">
                                    <h6 class="text-uppercase no-margin">${label}</h6>
                                </div>
                                <div class="preview-placeholder-item" style="background-image:url(${$item.thumb})" ></div>  
                            </div>`;
                    }
            }
            return template;            
        },
        saveAlbum:function(){
            $submitBTN = $('.upload-section .btn-save-album');
            $submitBTN.prop('disabled',true);
            $.ajax({
                url     : '/albums',
                data    : Uploader.data,
                type    : 'POST',
                success: function () {                            
                    $submitBTN.prop('disabled',false);
                    Uploader.prepareSubmitted();
                },
                error: function (data) {
                    $submitBTN.prop('disabled',false);
                    actionResponseModal( data.responseJSON.message || 'error', 'error');
                }
            }); 
        }
    };
}catch(e){
    console.log(e);
}

function labelClickFor($this){ 
    $("#"+$this.attr('for')).click();
}
*/